import CommitDiff from './CommitDiff';

export default CommitDiff;
